import { Button } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { createGrid, createRecordSource } from "../../rcsgrid/rcsgrid";
import { smetaModals } from "../../Tools/modalManager";
import styles from "./Components/styles.module.css";

interface GridObj {
  grid: createGrid;
  source: createRecordSource;
}

interface Props {
  props: {
    Buttons?: number | string;
    columns: { title: Array<any> };
    defaultFields: Array<any>;
    keyField: string;
    recordKeys: Array<string>;
    records: Array<any>;
    rights: string;
    setData: (newRecords: Array<any>) => void;
  };
  smetaModalId?: string;
}

export interface CheckData {
  CheckState: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DialogSimpleLocalTable({ props, smetaModalId }: Props) {
  const [mainGrid, setMainGrid] = useState<GridObj | undefined>();
  const [selectedRecordId, setSelectedRecordId] = useState("0");

  const gridPanel = useRef<HTMLDivElement | null>(null);

  const records = useRef<Array<any>>(props?.records || []);

  useEffect(() => {
    loadGrid();
  }, []);

  useEffect(() => {
    records.current = props?.records || [];
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    mainGrid && mainGrid.grid.refreshSource("!");
  }, [props]);

  const loadGrid = async () => {
    const res = await GridLoader(gridPanel.current, props, {
      localGrid: true,
      refresh: false,
      Columns: props.columns,
      defaultFields: props.defaultFields,
      keyField: props.keyField,
      recordKeys: props.recordKeys,
      Rights: props.rights,
      getRecords: () => records.current,
      setSelectedRecord: setSelectedRecordId,
      getFieldText: getFieldText,
      onPostRecord: changeRecordData,
    });
    setMainGrid(res);
  };

  const getFieldText = (request: { RecordIndex: number; FieldName: string }) => {
    if (records.current.length) {
      const recVal = records.current[request.RecordIndex];
      return { Text: recVal[request.FieldName]?.text || recVal[request.FieldName] };
    }
    return { Text: "" };
  };

  const changeRecordData = (request, recordData) => {
    const recVal = records.current[request.RecordIndex];
    const atributtes = request.RecordSet.Attributes;
    atributtes.forEach((field, index) => {
      records.current[request.RecordIndex] = { ...recVal, [field]: recordData[index].text };
    });
    props.setData?.(records.current);
  };

  return (
    <div className={clsx(styles.mainDialogBlock)}>
      <div className={clsx(styles.fullDialogFlexContainer, styles.dialogDayTypeContainer)}>
        <div ref={gridPanel} style={{ height: "100%", width: "100%", position: "relative" }}></div>
      </div>

      <div className={clsx(styles.dialogButtonsContainer)}>
        <Button
          size="small"
          variant="outlined"
          value="2"
          className={clsx(styles.dialogButton, "button_Modal_Close")}
          onClick={() => {
            smetaModals.close(smetaModalId);
          }}
        >
          Закрыть
        </Button>
      </div>
    </div>
  );
}
